import React from 'react'
import { Modal, Button } from "react-bootstrap"


function NoticeModal(props) {

  let modalTitle = "IMPORTANT NOTICE"

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter-notice">
          {modalTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please note that the value of securities and their income can fall as well as rise. Past performance should not be seen as an indication of future performance. Any views expressed are those of the author. You should contact the person at JM Finn with whom you usually deal if you wish to discuss the suitability of any securities mentioned. Prices quoted are as at close of business on <strong>{props.noticeDate}</strong>. Tax treatment depends on the individual circumstances of each client and may be subject to change in the future.</p>
        <strong>Data protection</strong>
        <p>If you no longer wish to receive a copy of Prospects and /or opt out of receiving marketing materials, including invitations to our seminars and events, please send an email to <a href="mailto:marketing@jmfinn.com">marketing@jmfinn.com</a>.</p>
        <p>We process your personal data in accordance with the law, and in particular with the UK General Data Protection Regulation of 1 January 2021. You have the right to object to the processing and use of your personal data, to access the data that we process, and to request that your data be deleted or that any errors in your data be corrected. To exercise these rights, you may write to us by post or by email. A copy of our <a href="/privacy-policy/">Privacy Policy</a> can be found on our website.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}



function ModalImportantNotice(props) {
  const [modalShow, setModalShow] = React.useState(false);
  const button = (
    <Button variant="primary" onClick={() => setModalShow(true)}>
      Please click here to read the important notice
    </Button>
  )

  return (
    <>
      {button}
      <NoticeModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        noticeDate={props.noticeDate}
      />
    </>
  )
}

export default ModalImportantNotice
